interface ServiceWorkerEnvironment {
  readonly production: boolean;
  readonly secureContext: boolean;
  readonly hostname: string;
  readonly serviceWorkerAvailable: boolean;
  readonly register: () => Promise<unknown>;
  readonly onLoad: (listener: () => void) => void;
}

function isLoopbackHostname(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

export function shouldRegisterServiceWorker(
  environment: Pick<
    ServiceWorkerEnvironment,
    'production' | 'secureContext' | 'hostname' | 'serviceWorkerAvailable'
  >,
): boolean {
  return (
    environment.production &&
    environment.serviceWorkerAvailable &&
    (environment.secureContext || isLoopbackHostname(environment.hostname))
  );
}

function browserEnvironment(): ServiceWorkerEnvironment {
  const serviceWorker = globalThis.navigator?.serviceWorker;
  return {
    production: import.meta.env.PROD,
    secureContext: globalThis.isSecureContext === true,
    hostname: globalThis.location?.hostname ?? '',
    serviceWorkerAvailable: Boolean(serviceWorker),
    register: () => serviceWorker?.register('/sw.js') ?? Promise.resolve(),
    onLoad: (listener) => globalThis.addEventListener('load', listener, { once: true }),
  };
}

export function registerServiceWorker(
  environment: ServiceWorkerEnvironment = browserEnvironment(),
): void {
  if (!shouldRegisterServiceWorker(environment)) return;

  environment.onLoad(() => {
    void environment.register().catch(() => {
      // The static-shell worker is an enhancement and must never block local initialization.
    });
  });
}
